import { stripAllPua } from "@nijiurachan/pua-command";

export type ThreadMetadata = Readonly<{
  title: string;
  /** og:title用のブランド表記なしタイトル（OGPガイドライン準拠） */
  ogTitle: string;
  description: string;
  canonical: string;
}>;

export function stripThreadFormatting(value: string): string {
  return stripAllPua(value);
}

export function normalizeThreadText(value: string): string {
  return stripThreadFormatting(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function truncate(value: string, max: number): string {
  const chars = Array.from(value);
  return chars.length > max ? `${chars.slice(0, max).join("")}…` : value;
}

/** Create identical metadata for the origin-rendered HTML and the SPA. */
export function createThreadMetadata(
  body: string,
  threadId: string,
  origin: string,
  siteName: string,
  publicBasePath: string,
): ThreadMetadata {
  const text = normalizeThreadText(body);
  const basePath = publicBasePath.replace(/\/+$/, "");
  const ogTitle = truncate(text || `No.${threadId}`, 10);
  return {
    title: `${ogTitle} - ${siteName}`,
    ogTitle,
    description: truncate(text || `${siteName}のスレッド`, 80),
    canonical: new URL(
      `${basePath}/thread/${encodeURIComponent(threadId)}`,
      origin,
    ).toString(),
  };
}
